import { SimpleModalService } from '../../simple-modal.service'
import { Inject, Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { map, switchMap, take } from 'rxjs/operators'
import { ActionProgressDialogActions } from './action-types'
import { Observable } from 'rxjs'
import { ActionProgressDialogComponent } from '../action-progress-dialog.component'
import { selectActionProgressDialogFeature } from './action-progress-dialog.selectors'

@Injectable()
export class ActionProgressDialogEffects {

    showDialog: Observable<any>

    constructor(
        @Inject(Actions) private actions$: Actions,
        @Inject(Store) private store: Store,
        @Inject(SimpleModalService) private simpleModalService: SimpleModalService,
    ) {
        this.showDialog = createEffect(() => this.actions$.pipe(
            ofType(ActionProgressDialogActions.showDialog),
            switchMap((action) => this.prepareShow(action.show).pipe(
                map(show => {
                    return ActionProgressDialogActions.setShow({ show: show, text: action.text })
                }),
            )),
        ))
    }

    private prepareShow(show: boolean): Observable<boolean> {
        return this.store.select(selectActionProgressDialogFeature).pipe(
            take(1),
            map((feature) => {
                if (feature.show === false && show === true) {
                    this.simpleModalService.addModal(ActionProgressDialogComponent)
                }
                return show
            }))
    }
}